import { Platform, StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import Touchable from '../../../elements/Touchable';

export const ITEM_WIDTH = 100;
export const ITEM_MARGIN = 5;

const S = {
  WatchMoreContainer: styled(Touchable)`
    margin: auto 30px;
  `,
  WatchMoreTextSection: styled.View`
    justify-content: center;
    align-items: center;
  `,
  WatchMoreText: styled.Text`
    font-size: 15px;
    line-height: 21px;
    color: ${({ theme }) => theme.palette.warrior};
    margin-top: 8px;
  `,
  ListItemFont: styled.Text`
    font-size: 13px;
    line-height: 18px;
  `,
  MoreTopSales: styled.View`
    flex-direction: row;
    align-items: center;
  `,
  /*
      web 在外層的 View 需要給 flex: 1，FlatList 才能滾動，且需有 flex-basis: auto 才能顯示 list：
      https://github.com/necolas/react-native-web/issues/1436#issuecomment-612845122
    */
  HorizontalContainer: styled.View`
    background-color: white;
    padding-bottom: 0;
    margin-bottom: 0;
    width: 100%;

    ${Platform.select({
      web: {
        flex: 1,
        flexBasis: 'auto',
      },
    })};
  `,
  HorizontalHeaderWrapper: styled.View`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
  `,
  HorizontalHeaderText: styled.Text`
    margin-left: 5px;
    font-size: 13px;
    color: ${({ theme }) => theme.palette.neutralDark};
  `,
  HorizontalHeaderLeft: styled.View`
    flex-direction: row;
    align-items: center;
  `,
  MoreTopRated: styled(Touchable)`
    flex-direction: row;
    align-items: center;
  `,
  MoreTopRatedText: styled.Text`
    font-size: 13px;
    color: ${({ theme }) => theme.palette.neutralDark};
  `,
};

export const styles = StyleSheet.create({
  horizontalListContainer: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  contentWrapperStyle: {
    minHeight: 70,
    paddingLeft: 0,
  },
  ListItemFontStyle: {
    fontSize: 11,
    lineHeight: 16,
  },
  listItemWrapperStyle: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
});

export default S;
